import { useState, useEffect } from "react";
import ProductCanvas from "./ProductCanvas";
import ProductInfo from "./ProductInfo";
import { products } from "./products.data";

export const PART_COLORS = [
  { label: "Medical Blue", value: "#2563eb" },
  { label: "Surgical Green", value: "#059669" },
  { label: "Neutral Gray", value: "#6b7280" },
  { label: "Alert Red", value: "#dc2626" },
];

const AUTO_ACTIVE_PARTS = ["V4A", "V4B", "V4_Orings"];

const ProductGallery: React.FC = () => {
  const product = products[0];

  const [rotateMode, setRotateMode] = useState(false);

  const [selectedParts, setSelectedParts] =
    useState<string[]>(AUTO_ACTIVE_PARTS);

  const [partColors, setPartColors] = useState({
    AB: "#2563eb",
    ORINGS: "#059669",
  });

  const [showInfo, setShowInfo] = useState(false);

  // ✅ Scroll Lock
  useEffect(() => {
    if (showInfo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showInfo]);

  return (
    <div className="w-full h-full flex flex-col lg:flex-row min-h-0">
      
      {/* ✅ BACKDROP (blocks interaction) */}
      {showInfo && (
        <div
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
          onClick={() => setShowInfo(false)}
        />
      )}

      {/* ✅ CANVAS SECTION */}
      <section
        className={`relative flex-1 overflow-hidden 
        bg-[linear-gradient(180deg,_#ffffff_0%,_#f3f6f9_60%,_#eef2f6_100%)]
        ${showInfo ? "pointer-events-none" : ""}`}
      >
        {/* vignette */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,_transparent_60%,_rgba(0,0,0,0.05)_100%)]" />

        {/* Rotate Button */}
        <button
          onClick={() => setRotateMode(!rotateMode)}
          className="lg:hidden absolute bottom-4 left-4 z-40
             bg-black/80 text-white px-4 py-2 rounded-full text-sm"
        >
          {rotateMode ? "Done" : "Rotate"}
        </button>

        <ProductCanvas
          parts={product.parts}
          activeParts={selectedParts}
          activeColors={partColors}
          rotateMode={rotateMode}
        />

        {/* Open Popup */}
        <button
          onClick={() => setShowInfo(true)}
          className="lg:hidden absolute bottom-4 right-4 bg-primary text-white px-4 py-2 rounded-full text-sm shadow-lg"
        >
          View Colors
        </button>
      </section>

      {/* ✅ POPUP / SIDEBAR */}
      <aside
        className={`
          bg-white lg:border-l
          w-full lg:w-[38%] xl:w-[35%]
          fixed lg:static inset-x-0 bottom-0 z-40
          h-[75%] sm:h-[70%] lg:h-full
          transition-transform duration-300
          ${
            showInfo
              ? "translate-y-0"
              : "translate-y-full lg:translate-y-0"
          }
        `}
      >
        <div className="flex flex-col h-full">
          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto">
            <ProductInfo
              product={product}
              selectedParts={selectedParts}
              onPartsChange={setSelectedParts}
              partColors={partColors}
              onPartColorChange={(key, color) =>
                setPartColors((prev) => ({ ...prev, [key]: color }))
              }
            />
          </div>

          {/* Close Button */}
          <div className="lg:hidden p-4 border-t">
            <button
              onClick={() => setShowInfo(false)}
              className="w-full bg-primary text-white py-2 rounded-lg"
            // className="lg:hidden bottom-4 right-4 bg-primary text-white px-4 py-2 rounded-full text-sm shadow-lg"
            >
              Close
            </button>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default ProductGallery;